import { render, staticRenderFns } from "./WeekData.vue?vue&type=template&id=bd1bccd2&scoped=true&"
import script from "./WeekData.vue?vue&type=script&lang=js&"
export * from "./WeekData.vue?vue&type=script&lang=js&"
import style0 from "./WeekData.vue?vue&type=style&index=0&id=bd1bccd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1bccd2",
  null
  
)

export default component.exports